import { getField, updateField } from 'vuex-map-fields'
import getTodoNoteFiltersModel from './models/todoNoteFilters'
import getPagingAndSortingModel from './models/pagingAndSorting'
import { clearPagingAndSortingState } from '@/lib/pagingAndSorting'

const todoNoteFilters = {
  namespaced: true,
  state: {
    ...getTodoNoteFiltersModel(),
    paging: { ...getPagingAndSortingModel({ sortBy: 'createAt' }) }
  },
  getters: {
    getField,
    getSearchObject (state) {
      return state
    }
  },
  actions: {
    clearFilters ({ commit }) {
      commit('clearFilters')
      return commit('clearPagingAndSorting')
    },
    clearPagingAndSorting: ({ commit }) => {
      return commit('clearPagingAndSorting')
    }
  },
  mutations: {
    updateField,
    clearFilters (state) {
      state.todoId = null
      state.createAt = null
      state.createdBy = null
    },
    clearPagingAndSorting: (state) => {
      clearPagingAndSortingState(state, { sortBy: 'createAt' })
    }
  }
}

export default todoNoteFilters
